export default {
    capitalize: (string) => {
        try {
            return string.toLowerCase().replace(
                /(^|[ ,-])([a-zà-ÿ])/g,
                (m, p1, p2) => {
                    return p1 + p2.toUpperCase();
                }
            );
        } catch (e) {
            return string;
        }
    }
} 